import { MrvDataBM } from '../types/BusinessModel/MrvDataBM';
import { MrvData } from '../types/ViewModel/MrvData';

export class MrvDataFactory {
    public create(data: MrvDataBM): MrvData {
        return new MrvData(
            data.type,
            data.anchoringHours,
            data.observedDistance,
            data.mainEngineConsumptionHfo,
            data.mainEngineConsumptionMgo,
            data.auxiliaryEngineConsumptionHfo,
            data.auxiliaryEngineConsumptionMgo,
            data.boilersConsumptionHfo,
            data.boilersConsumptionMgo,
            data.dieselDrivenPowerpacksConsumptionMgo,
            data.boilersConsumptionForCargoHeatingHfo,
            data.boilersConsumptionForCargoHeatingMgo,
            data.durationInHours,
            data.localTimeOffsetInHours,
            data.mrvDataRequired,
            data.eventDateTimeUtc,
            data.eventDateTimeLocalTime,
            data.eospUtc,
            data.sospUtc
        );
    }

    public createList(data: MrvDataBM[]): MrvData[] {
        return data.map((h) => this.create(h));
    }
}
